<script lang="ts">
	import type { ISbStoryData } from '@storyblok/js';
	import { editable } from '../editable';
	import Blok from '../blok.svelte';

	interface Props {
		content: ISbStoryData<{
			items: ISbStoryData[];
			box_items_label: string;
			box_items: ISbStoryData[];
		}>['content'];
	}

	let { content }: Props = $props();
</script>

<section use:editable={content} class="mb-4 pb-6 pt-4">
	<div class="flex flex-col">
		{#each content.items as item}
			<div class="border-b-[0.5px] border-stone-2 py-4 lg:py-8">
				<Blok content={item} />
			</div>
		{/each}
	</div>
	<div class="flex flex-col text-brown-1 lg:flex-row">
		{#if content.box_items_label?.length > 0}
			<h1
				class="mt-5 text-[20px]/[140%] tracking-[-.2px] lg:basis-1/2 lg:text-[16px]/[150%] lg:tracking-[-.16px]"
			>
				{content.box_items_label}
			</h1>
		{/if}
		<div class="-ml-11 mt-8 flex flex-wrap gap-y-6 lg:basis-1/2">
			{#each content.box_items as item}
				<div class="flex-1 basis-1/2 lg:basis-1/3">
					<Blok content={item} />
				</div>
			{/each}
		</div>
	</div>
</section>

<style lang="scss">
	section {
		:global {
			p:not(:last-child) {
				margin: theme('spacing.2') 0;
			}
		}
	}
</style>
